import { Card, TableColumnsType, Tag } from "antd";

import TableUi from "../../../../../../atoms/Table";
import { useState } from "react";

export default function TabMaterials() {
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const columns: TableColumnsType = [
    {
      title: "Material Name",
      dataIndex: "material_name",
      width: 400,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.material_name?.localeCompare(b?.material_name),
      fixed: "left",
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.unit?.localeCompare(b?.unit),
      fixed: "left",
    },
    {
      title: "Estimated",
      dataIndex: "estimated",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.estimated?.localeCompare(b?.estimated),
    },
    {
      title: "Allocated",
      dataIndex: "allocated",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.allocated?.localeCompare(b?.allocated),
    },
    {
      title: "On order",
      dataIndex: "on_order",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.on_order?.localeCompare(b?.on_order),
    },
    {
      title: "Used to date",
      dataIndex: "used_to_date",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.used_to_date?.localeCompare(b?.used_to_date),
    },
    {
      title: "Purchase orders",
      dataIndex: "purchase_orders",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.purchase_orders?.localeCompare(b?.purchase_orders),
    },
    {
      title: "Work orders",
      dataIndex: "work_orders",
      width: 150,
      render: (text) => {
        return text ? <Tag>{text}</Tag> : "-";
      },
      sorter: (a, b) => a?.work_orders?.localeCompare(b?.work_orders),
    },
  ];

  const dummyArray = [
    {
      key: "1",
      material_name: "Boxwood Shrub (3 Gal)",
      unit: "pc",
      estimated: "75",
      allocated: "57",
      on_order: "18",
      used_to_date: "40",
      purchase_orders: "PO #1267678",
      work_orders: "Softscape installation",
    },
    {
      key: "2",
      material_name: "Concrete Paver 4x8",
      unit: "pc",
      estimated: "1500",
      allocated: "821",
      on_order: "679",
      used_to_date: "796",
      purchase_orders: "PO #867456",
      work_orders: "Hardscape installation",
    },
    {
      key: "3",
      material_name: "Concrete Sand",
      unit: "cy",
      estimated: "120",
      allocated: "68",
      on_order: "52",
      used_to_date: "57",
      purchase_orders: "PO #1267678",
      work_orders: "Hardscape installation",
    },
    {
      key: "4",
      material_name: 'Crushed Gravel (3/4" minus)',
      unit: "cy",
      estimated: "100",
      allocated: "46",
      on_order: "54",
      used_to_date: "45",
      purchase_orders: "PO #1267678",
      work_orders: "Hardscape installation",
    },
    {
      key: "5",
      material_name: "Daylily (1 Gal)",
      unit: "pc",
      estimated: "60",
      allocated: "40",
      on_order: "20",
      used_to_date: "31",
      purchase_orders: "PO #1267679",
      work_orders: "Landscape design",
    },
    {
      key: "6",
      material_name: "Large Format Paver (24x24)",
      unit: "pc",
      estimated: "300",
      allocated: "177",
      on_order: "123",
      used_to_date: "148",
      purchase_orders: "PO #1267680",
      work_orders: "Irrigation system",
    },
    {
      key: "7",
      material_name: "Polymeric Sand",
      unit: "lbs",
      estimated: "2000",
      allocated: "927",
      on_order: "1073",
      used_to_date: "924",
      purchase_orders: "PO #1267681",
      work_orders: "Paving stones",
    },
    {
      key: "8",
      material_name: 'Ready-Mix Concrete (4" thick)',
      unit: "cy",
      estimated: "90",
      allocated: "57",
      on_order: "33",
      used_to_date: "44",
      purchase_orders: "PO #1267682",
      work_orders: "Decking installation",
    },
    {
      key: "9",
      material_name: "Rebar #3",
      unit: "ft",
      estimated: "1200",
      allocated: "559",
      on_order: "641",
      used_to_date: "544",
      purchase_orders: "PO #1267683",
      work_orders: "Fencing setup",
    },
    {
      key: "10",
      material_name: 'Red Maple 2" Caliper B&B',
      unit: "pc",
      estimated: "15",
      allocated: "22",
      on_order: "0",
      used_to_date: "8",
      purchase_orders: "PO #1267684",
      work_orders: "Planting trees",
    },
    {
      key: "11",
      material_name: "Screened Topsoil",
      unit: "cy",
      estimated: "80",
      allocated: "45",
      on_order: "35",
      used_to_date: "38",
      purchase_orders: "PO #1267685",
      work_orders: "Soil preparation",
    },
    {
      key: "12",
      material_name: "Shredded Hardwood Mulch",
      unit: "cy",
      estimated: "60",
      allocated: "43",
      on_order: "17",
      used_to_date: "30",
      purchase_orders: "PO #1267686",
      work_orders: "Mulching",
    },
    {
      key: "13",
      material_name: "St. Augustine Sod",
      unit: "sf",
      estimated: "8000",
      allocated: "3871",
      on_order: "4129",
      used_to_date: "3849",
      purchase_orders: "PO #1267687",
      work_orders: "Sod installation",
    },
    {
      key: "14",
      material_name: "Straw Mulch",
      unit: "bales",
      estimated: "100",
      allocated: "77",
      on_order: "23",
      used_to_date: "50",
      purchase_orders: "PO #1267688",
      work_orders: "Rock placement",
    },
    {
      key: "15",
      material_name: "Tree Stakes & Ties Kit",
      unit: "sets",
      estimated: "15",
      allocated: "31",
      on_order: "0",
      used_to_date: "7",
      purchase_orders: "PO #1267689",
      work_orders: "Water feature construction",
    },
    {
      key: "16",
      material_name: "Turf Grass Seed Blend",
      unit: "lbs",
      estimated: "250",
      allocated: "146",
      on_order: "104",
      used_to_date: "117",
      purchase_orders: "PO #1267690",
      work_orders: "Outdoor lighting",
    },
  ];

  return (
    <div className="dashboard-tab">
      <Card className="scope_n_pricing table_area_scope">
        <TableUi
          columns={columns}
          data={{
            count: dummyArray?.length,
            data: dummyArray || [],
          }}
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </Card>
    </div>
  );
}
